module.exports = __webpack_public_path__ + "img/01_小红书热贡艺术.d931037b.png";